import useTranslation from 'next-translate/useTranslation';
import styles from './styles.module.scss';
import { RootState } from '@/lib/store';
import { UserRestriction } from '@/models/user-restriction';
import { useSelector } from 'react-redux';
import { getDescription } from './helpers';
import { TransWithDefault } from '@starsoft/common/components';
import { Nullable } from '@starsoft/common/interfaces';
import { Restriction } from '@/models/restriction';

export default function RestrictionDetailsModalDescription() {
  const userRestrictions: UserRestriction[] = useSelector(
    (state: RootState) => state.userRestrictions.userRestrictions,
  );
  const restriction: Nullable<Restriction> = useSelector(
    (state: RootState) => state.userRestrictions.restriction,
  );

  const description = getDescription(userRestrictions);

  if (!!restriction) {
    return null;
  }

  return (
    <div className={styles.container}>
      <p className={styles.container__description}>
        <TransWithDefault i18nKey={`common:${description}`} />
      </p>
    </div>
  );
}
